import { brGet } from '../brRequestWrapper';
import { ApiRoutes } from '../apiRoutes';

interface ArFeaturesResponse {
  billingReminderV2Enabled: boolean;
}

export const getArFeaturesAsync = async (): Promise<ArFeaturesResponse> => {
  const response = await brGet<ArFeaturesResponse>(ApiRoutes.ArFeatures);
  return response.data;
};
